<template>
  <el-card class="h-full">
    <div class="flex mb-20px mr-10px">
      <el-input
        size="small"
        class="mr-10px !w-50"
        placeholder="请输入关键字"
        v-model="equipSearchData.searchKeyword"
        clearable
      ></el-input>
      <department-select
        ref="departmentSelect"
        class="mr-10px !w-50"
        v-model="equipSearchData.departmentId"
      ></department-select>
      <el-date-picker
        class="mr-10px"
        v-model="equipSearchData.datePickerValue"
        format="yyyy-MM-dd"
        size="small"
        type="daterange"
        :clearable="true"
        start-placeholder="开始时间"
        end-placeholder="结束时间"
        value-format="yyyy-MM-dd"
      >
      </el-date-picker>
      <el-select
        v-model="equipSearchData.incident"
        size="small"
        class="mr-10px !w-50"
        placeholder="请选择事件"
        clearable
        filterable
      >
        <el-option
          v-for="item in hiddenList"
          :key="item.label"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-button size="small" type="primary" @click="handleSearch()">搜索</el-button>
      <el-button size="small" @click="resetText()">重置</el-button>
      <el-button
        size="small"
        type="danger"
        @click="handleEvent(null, 'batchDelete')"
        :disabled="!$hasAccess('delete')"
        >批量删除</el-button
      >
      <el-button
        size="small"
        @click="handleEvent(null, 'batchExport')"
        :disabled="!$hasAccess('batchExport')"
        >导出</el-button
      >
    </div>
    <el-table
      :data="equipDataList"
      border
      class="w-full"
      :height="tableHeight"
      stripe
      v-loading="equipTableLoading"
      @selection-change="handleSelectionEquip"
    >
      <el-table-column type="selection" width="50"></el-table-column>
      <el-table-column label="序号" type="index" width="50"></el-table-column>
      <el-table-column
        label="被考核人员"
        prop="assessorName"
        width="180"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        label="所属部门"
        width="180"
        prop="departmentName"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        label="积分下发时间"
        prop="integralDeliveryTime"
        width="260"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          {{
            scope.row.integralDeliveryTime
              ? dayjs(scope.row.integralDeliveryTime).format('YYYY-MM-DD HH:mm:ss')
              : ''
          }}
        </template>
      </el-table-column>
      <el-table-column label="事件" prop="incident" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.incident == 0">按期排查任务</span>
          <span v-if="scope.row.incident == 1">上报重大隐患</span>
          <span v-if="scope.row.incident == 2">上报一般隐患</span>
          <span v-if="scope.row.incident == 3">完成隐患整改</span>
          <span v-if="scope.row.incident == 4">隐患排查超期</span>
          <span v-if="scope.row.incident == 5">隐患超期未整改</span>
          <span v-if="_.isNil(scope.row.incident)"></span>
        </template>
      </el-table-column>
      <el-table-column
        label="奖惩积分"
        prop="rewardAndPunishmentIntegral"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="操作" width="100" fixed="right">
        <template slot-scope="scope">
          <table-operate-button :key="scope.row.id" :buttons="buttonsEquip(scope.row)" />
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      @size-change="equipTableSizeChange"
      @current-change="equipTableCurrentChange"
      :current-page.sync="equipPageConfig.SkipCount"
      :page-size.sync="equipPageConfig.MaxResultCount"
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="[15, 30, 45, 60, 75, 90]"
      :total="equipTotalCount"
      class="float-right mt-20px ml-10px"
    ></el-pagination>
  </el-card>
</template>

<script>
import dayjs from 'dayjs'
import TableOperateButton from '@/components/safety/TableOperateButton/TableOperateButton'
import { PointApi } from '@wiz-api/double-prevention-management'
import DepartmentSelect from '@/components/safety/DepartmentSelect/DepartmentSelect'
import utils from '@/components/safety/enumField/utils'

const pointApi = new PointApi()

export default {
  name: 'score-records',
  components: {
    TableOperateButton,
    DepartmentSelect,
  },
  data() {
    return {
      userList: [],
      // 设备设施清单
      equipDataList: [],
      equipTableLoading: false,
      equipTotalCount: 0,
      equipSearchData: {
        searchKeyword: '',
        departmentId: undefined,
        incident: undefined,
        datePickerValue: [],
        startTime: undefined,
        endTime: undefined,
      },
      equipPageConfig: {
        SkipCount: 1,
        MaxResultCount: 15,
      },
      selectionEquipData: [],
      hiddenList: [
        {
          label: '按期排查任务',
          value: 0,
        },
        {
          label: '上报重大隐患',
          value: 1,
        },
        {
          label: '上报一般隐患',
          value: 2,
        },
        {
          label: '完成隐患整改',
          value: 3,
        },
        {
          label: '隐患排查超期',
          value: 4,
        },
        {
          label: '隐患超期未整改',
          value: 5,
        },
      ],
    }
  },
  created() {
    this.getEquipList()
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 110px)'
    },
    buttonsEquip() {
      return (val) => {
        return [
          {
            text: '删除',
            click: () => {
              return this.handleEvent(val, 'delete')
            },
            isShow: this.$hasAccess('delete') && val.isMarkers,
          },
        ]
      }
    },
  },
  methods: {
    resetText() {
      this.equipSearchData = this.$options.data().equipSearchData
      this.$refs.departmentSelect.userName = ''
      this.handleSearch()
    },
    // 列表操作-事件 设备设施清单
    async handleEvent(row = null, operation) {
      let err = null
      let res = null
      switch (operation) {
        case 'delete':
          this.$confirm('是否删除该记录？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(async () => {
              ;[err, res] = await pointApi.deletePointRecords({ guids: [row.id] })
              if (!err) {
                this.$message({
                  showClose: true,
                  message: '删除成功',
                  type: 'success',
                })
                this.getEquipList()
              }
            })
            .catch(() => {})
          break
        case 'batchExport':
          if (!this.selectionEquipData || this.selectionEquipData.length === 0) {
            this.$message({
              showClose: true,
              message: '请勾选要导出的记录',
              type: 'warning',
            })
            return
          }
          let rowIds = _.map(this.selectionEquipData, (item) => {
            return item.id
          })
          ;[err, res] = await pointApi.exportPointRecord({
            body: rowIds,
          })
          if (!err) {
            this.downLoadExcel('积分记录', res)
            this.$message({
              showClose: true,
              message: '导出成功',
              type: 'success',
            })
          }
          break
        // 批量删除
        case 'batchDelete':
          if (!this.selectionEquipData || this.selectionEquipData.length === 0) {
            this.$message({
              showClose: true,
              message: '请勾选要删除的记录',
              type: 'warning',
            })
            return
          }
          const isDelete = _.every(this.selectionEquipData, (item) => {
            return item.isMarkers
          })
          if (!isDelete) {
            this.$message({
              showClose: true,
              message: '存在不允许删除的记录',
              type: 'warning',
            })
            return
          }
          rowIds = _.map(this.selectionEquipData, (item) => {
            return item.id
          })
          this.$confirm('是否批量删除勾选的记录', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(async () => {
              ;[err, res] = await pointApi.deletePointRecords({ guids: rowIds })
              if (!err) {
                this.$message({
                  showClose: true,
                  message: '删除成功',
                  type: 'success',
                })
                this.getEquipList()
              }
            })
            .catch(() => {})
          break
        default:
          break
      }
    },
    downLoadExcel(fileName = '下载文件', data) {
      const blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `${fileName}`
      link.click()
      window.URL.revokeObjectURL(link.href)
    },
    handleSelectionEquip(values) {
      this.selectionEquipData = values
    },
    // 搜索
    handleSearch() {
      this.equipPageConfig.SkipCount = 1
      this.getEquipList()
    },
    // 页码改变
    equipTableSizeChange(MaxResultCount) {
      this.equipPageConfig.MaxResultCount = MaxResultCount
      this.getEquipList()
    },
    // 页数改变
    equipTableCurrentChange(SkipCount) {
      this.equipPageConfig.SkipCount = SkipCount
      this.getEquipList()
    },
    // 设备设施列表
    async getEquipList() {
      this.selectionEquipData = []
      this.equipSearchData.startTime =
        this.equipSearchData.datePickerValue && this.equipSearchData.datePickerValue.length === 2
          ? dayjs(this.equipSearchData.datePickerValue[0]).format('YYYY-MM-DD')
          : undefined
      this.equipSearchData.endTime =
        this.equipSearchData.datePickerValue && this.equipSearchData.datePickerValue.length === 2
          ? dayjs(this.equipSearchData.datePickerValue[1]).format('YYYY-MM-DD')
          : undefined
      const equipSearchData = utils.deleteFormField(this.equipSearchData)
      const data = {
        maxResultCount: this.equipPageConfig.MaxResultCount, // 每页多少条
        skipCount: (this.equipPageConfig.SkipCount - 1) * this.equipPageConfig.MaxResultCount, // 跳过多少条
        ...equipSearchData,
      }
      this.equipTableLoading = true
      const [err, res] = await pointApi.getPointsList(data)
      if (!err) {
        this.equipDataList = res.items
        this.equipTotalCount = res.totalCount
      }
      this.equipTableLoading = false
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-card__body {
  height: 100%;
}
</style>
